// 引入cookies
// import { get } from '../utils/cookies'
import Vue from 'vue';
import VueRouter from 'vue-router';
// eslint-disable-next-line no-multi-spaces
import HomeView from '../views/home.vue'; // 公共首页
// eslint-disable-next-line no-multi-spaces
import LoginView from '../views/login.vue'; // 登录页面
// eslint-disable-next-line no-multi-spaces
import NotFound from '../components/error.vue'; // 404界面
// eslint-disable-next-line spaced-comment
import PdaList from '../views/pdaList/pdaList.vue'; //智慧养殖首页
// eslint-disable-next-line no-multi-spaces
// import PdaLists from '../views/pdaLists/pdaList.vue'  // 智慧畜牧
import slaughterHouse from '../views/SmartLivestock/slaughterHouse/current.vue'; // 智慧屠宰
// eslint-disable-next-line no-multi-spaces
import Index from '../views/index.vue'; // 畜牧首页框架
import ezviz from '@/components/ezviz.vue'; //map
import showData from '../views/SmartLivestock/statistics/showData.vue'; // 大数据 智慧畜牧
import SmartLivestock from './SmartLivestock'; // 智慧畜牧
import zzry from './zzry'; // 智慧畜牧

const visualization = () => import('@/views/SmartLivestock-zzry/statisticsLevel/visualization.vue'); // 大数据展示

// const openInternet = () => import('@/views/openInternet/statistics/showData.vue'); // 大数据展示

const easyplayerVideo = () => import('@/components/easyplayerVideo.vue'); // 测试视频播放

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

// 靖边县 - 大屏
const screenJB = () => import('@/views/externalScreen/index.vue');
// 练习 - 大屏布局
const hppdome = () => import('@/views/hppdome/index.vue');
Vue.use(VueRouter);
const routes = [
  ...SmartLivestock,
  ...zzry,
  {
    path: '/',
    redirect: '/home'
  },
  // 公共主页
  {
    path: '/home',
    component: HomeView
  },
  // 练习 - 大屏布局
  {
    path: '/hppdome',
    component: hppdome
  },
  // 靖边县 - 大屏
  {
    path: '/screenJB',
    component: screenJB
  },
  // 大屏 - 上河
  {
    path: '/largeScreenSH',
    component: () => import('../views/poultryStorage/largeScreenSH/index.vue')
  },
  // 四川-算法演示
  {
    path: '/livestockDemo',
    component: () => import('../views/livestockDemo/index.vue')
  },
  // 测试视频播放
  {
    path: '/easyplayerVideo',
    component: easyplayerVideo
  },
  {
    path: '/ezviz',
    component: ezviz
  },
  {
    path: '/showData',
    component: showData
  },
  // 登录页面
  {
    path: '/login',
    component: LoginView
  },
  // 404界面
  {
    path: '*',
    component: NotFound
  },
  // 智慧养殖
  {
    path: '/pdaList/datas',
    component: PdaList
  },
  // 智慧畜牧(新大屏)
  {
    path: '/visualization',
    component: visualization
  },
  // {
  //   path: '/openInternet',
  //   component: openInternet
  // },

  // 智慧屠宰
  {
    path: '/slaughterHouse/passageManage',
    component: slaughterHouse
  },
  // 侧边栏路由
  // 智慧养殖
  {
    path: '/homeZ',
    component: Index,
    children: [
      {
        path: 'homear',
        component: () => import('../views/index/indexzhyz.vue')
      },
      {
        path: 'slaughterList',
        component: () => import('../views/SmartLivestock/slaughterHouse/list.vue')
      },
      {
        path: 'slaughterCur',
        component: () => import('../views/SmartLivestock/slaughterHouse/current.vue')
      },
      {
        path: 'datas',
        component: () => import('../views/SmartLivestock/datas/datas.vue')
      },
      {
        path: 'datasCustom',
        component: () => import('../views/SmartLivestock/datasCustom/index.vue')
      },
      {
        path: 'statement',
        component: () => import('../views/SmartLivestock/datas/statisticalStatement.vue')
      },
      {
        path: 'pdaList',
        component: () => import('../views/pdaList/pdaList.vue')
      },
      {
        path: 'smartDevices',
        component: () => import('../views/smartDevices/smartDevices.vue') // 智慧养殖 - 智能设备 - 设备列表
      },
      {
        path: 'perceivedState',
        component: () => import('../views/smartDevices/perceivedState.vue') // 智慧养殖 - 智能设备 - 感知状态一张图
      },
      {
        path: 'regulatorySystem',
        component: () => import('../views/smartDevices/regulatorySystem.vue') // 智慧养殖 - 智能设备 - 精准调控系统
      },

      {
        path: 'distinguish',
        component: () => import('../views/housingManagement/distinguish.vue') // 智慧养殖 - 圈舍管理 - 区管理
      },
      {
        path: 'shedManagement',
        component: () => import('../views/housingManagement/shedManagement.vue') // 智慧养殖 - 圈舍管理 - 棚管理
      },
      {
        path: 'columnManagement',
        component: () => import('../views/housingManagement/columnManagement.vue') // 智慧养殖 - 圈舍管理 - 栏管理
      },
      {
        path: 'feedingVehicles',
        component: () => import('../views/feedingManagement/index.vue') // 饲喂管理 - 饲喂车辆
      },
      {
        path: 'feedingRecords',
        component: () => import('../views/feedingManagement/records.vue') // 饲喂管理 - 饲喂记录
      },
      {
        path: 'tmr',
        component: () => import('../views/feedingManagement/tmr.vue') // 饲喂管理 - TMR中央厨房
      },
      {
        path: 'mixture',
        component: () => import('../views/feedingManagement/mixture.vue') // 饲喂管理 - 混料/出料记录
      },
      {
        path: 'user',
        component: () => import('../views/SmartLivestock/systemSettings/user.vue')
      },
      {
        path: 'userGroup',
        component: () => import('../views/SmartLivestock/systemSettings/userGroup.vue')
      },
      {
        path: 'userCaidan',
        component: () => import('../views/SmartLivestock/systemSettings/userCaidan.vue')
      },
      {
        path: 'operationLog',
        component: () => import('../views/SmartLivestock/systemSettings/operationLog.vue')
      },
      {
        path: 'loginLog',
        component: () => import('../views/SmartLivestock/systemSettings/loginLog.vue')
      },
      {
        path: 'colonyHouse',
        component: () => import('../views/pdaList/colonyHouse.vue')
      },
      {
        path: 'aisle',
        component: () => import('../views/pdaList/aisle.vue')
      },
      {
        path: 'car',
        component: () => import('../views/pdaList/car.vue')
      },
      {
        path: 'intheBar',
        component: () => import('../views/livestock/intheBar.vue')
      },
      {
        path: 'immune',
        component: () => import('../views/livestock/immune.vue')
      },
      {
        path: 'medicine',
        component: () => import('../views/livestock/medicine.vue')
      },
      {
        path: 'breed',
        component: () => import('../views/livestock/breed.vue')
      },
      {
        path: 'such',
        component: () => import('../views/livestock/such.vue')
      },
      {
        path: 'weight',
        component: () => import('../views/livestock/weight.vue')
      },
      {
        path: 'animalHeat',
        component: () => import('../views/livestock/animalHeat.vue')
      },
      {
        path: 'stepNumber',
        component: () => import('../views/livestock/stepNumber.vue')
      },
      {
        path: 'location',
        component: () => import('../views/livestock/location.vue')
      },
      {
        path: 'info',
        component: () => import('../views/materialZ/info.vue')
      },
      {
        path: 'list',
        component: () => import('../views/materialZ/list.vue')
      },
      {
        path: 'out',
        component: () => import('../views/materialZ/out.vue')
      }
    ]
  },
  // 屠宰场
  {
    path: '/homeT',
    component: Index,
    children: [
      {
        path: 'passageManage',
        component: () => import('../views/SmartSlaughter/passageManage/index')
      },
      {
        path: 'orderManage',
        component: () => import('../views/SmartSlaughter/orderManage/index')
      },
      {
        path: 'padList',
        component: () => import('../views/pdaList/pdaList.vue')
      },
      {
        path: 'aiStatistics',
        component: () => import('../views/pdaList/aiStatistics.vue')
      },
      {
        path: 'xmds',
        component: () => import('../views/pdaList/xmds.vue')
      }
    ]
  },
  // 见犊补母
  {
    path: '/homeB',
    component: Index,
    children: [
      // 首页
      {
        path: 'index',
        component: () => import('../views/cattlesubsidy/index')
      },
      // 强制免疫
      {
        path: 'compulsoryimmunity',
        component: () => import('../views/cattlesubsidy/compulsoryimmunity')
      },
      // 防疫大屏
      {
        path: 'screenEpidemic',
        component: () => import('../views/cattlesubsidy/screenEpidemic.vue')
      },
      // 设备查看
      {
        path: 'deviceview',
        component: () => import('../views/cattlesubsidy/deviceview')
      },
      // 产业主体管理
      {
        path: 'Industrial',
        component: () => import('../views/cattlesubsidy/Industrial.vue')
      },
      // 设备申请
      {
        path: 'Equipmentapplication',
        component: () => import('../views/cattlesubsidy/Equipmentapplication.vue')
      },
      // 信息员管理
      {
        path: 'Informationofficer',
        component: () => import('../views/cattlesubsidy/Informationofficer.vue')
      },
      // 可视化大屏管理
      {
        path: 'visualLargeScreen',
        component: () => import('../views/cattlesubsidy/visualLargeScreen/index')
      },
      {
        path: 'materialLnfo',
        component: () => import('../views/cattlesubsidy/material/info.vue')
      },
      {
        path: 'materialList',
        component: () => import('../views/cattlesubsidy/material/list.vue')
      },
      // 畜只管理
      {
        path: 'livestockmanagement',
        component: () => import('../views/cattlesubsidy/livestockmanagement.vue')
      },
      // 配种机构管理
      {
        path: 'breedingmechanism',
        component: () => import('../views/cattlesubsidy/breedingmechanism.vue')
      },
      // 配种机构管理
      {
        path: 'policy',
        component: () => import('../views/cattlesubsidy/contentRelease/policy.vue')
      },
      // 信息上报
      {
        path: '/subsidyapplication',
        component: { render: e => e('router-view') },
        children: [
          // 生产上报
          {
            path: 'production',
            component: () => import('../views/cattlesubsidy/subsidyapplication/production.vue')
          },
          // 死亡上报
          {
            path: 'die',
            component: () => import('../views/cattlesubsidy/subsidyapplication/die.vue')
          },
          // 配种信息上报
          {
            path: 'matingInfo',
            component: () => import('../views/cattlesubsidy/subsidyapplication/matingInfo.vue')
          },
          // 配种申请
          {
            path: 'applicationMating',
            component: () => import('../views/cattlesubsidy/subsidyapplication/applicationMating.vue')
          }
        ]
      }
    ]
  },

  // 种畜禽
  {
    path: '/livestock',
    component: Index,
    children: [
      // 大屏
      {
        path: 'largeScreen',
        component: () => import('../views/poultryStorage/largeScreen/index.vue')
      },
      // 监控设备
      {
        path: 'deviceview',
        component: () => import('../views/poultryStorage/deviceview/index.vue')
      },
      // 种畜禽场管理
      {
        path: 'poultryFarm',
        component: () => import('../views/poultryStorage/poultryFarm/index.vue')
      },
      // 产业主体管理
      {
        path: 'subjectManagement',
        component: () => import('../views/poultryStorage/subjectManagement/index.vue')
      },
      // 养殖生产管理 - 在栏种畜
      {
        path: 'inTheColumn',
        component: () => import('../views/poultryStorage/LivestockMan/inTheColumn.vue')
      },
      // 养殖生产管理 - 配种/繁育
      {
        path: 'breeding',
        component: () => import('../views/poultryStorage/LivestockMan/breeding.vue')
      },
      // 养殖生产管理 - 免疫接种
      {
        path: 'immunization',
        component: () => import('../views/poultryStorage/LivestockMan/immunization.vue')
      },
      // 养殖生产管理 - 防疫监测
      {
        path: 'monitor',
        component: () => import('../views/poultryStorage/LivestockMan/monitor.vue')
      },
      // 养殖生产管理 - 诊疗用药
      {
        path: 'medication',
        component: () => import('../views/poultryStorage/LivestockMan/medication.vue')
      },
      // 养殖生产管理 - 环境消杀
      {
        path: 'environment',
        component: () => import('../views/poultryStorage/LivestockMan/environment.vue')
      },
      // 养殖生产管理 - 出栏销售
      {
        path: 'circulation',
        component: () => import('../views/poultryStorage/LivestockMan/circulation.vue')
      },
      // 养殖生产管理 - 无害化处理
      {
        path: 'eliminate',
        component: () => import('../views/poultryStorage/LivestockMan/eliminate.vue')
      },
      // 种畜认证申请
      {
        path: 'authentication',
        component: () => import('../views/poultryStorage/authentication/index.vue')
      },
      // 物料管理 - 物料信息
      {
        path: 'material',
        component: () => import('../views/poultryStorage/material/material.vue')
      },
      // 物料管理 - 入库记录
      {
        path: 'storageRecord',
        component: () => import('../views/poultryStorage/material/storageRecord.vue')
      },
      // 物料管理 - 使用记录
      {
        path: 'usageRecord',
        component: () => import('../views/poultryStorage/material/usageRecord.vue')
      },
      // 系谱档案管理 - 系谱图
      {
        path: 'genealogyChart',
        component: () => import('../views/poultryStorage/genealogy/genealogyChart.vue')
      },
      // 系谱档案管理 - 近交系数
      {
        path: 'inbreedingCoefficient',
        component: () => import('../views/poultryStorage/genealogy/inbreedingCoefficient.vue')
      },
      // 育种测定管理 - 指标值配置
      {
        path: 'performance',
        component: () => import('../views/poultryStorage/guota/performance.vue')
      },
      // 育种测定管理 - 指标项配置
      {
        path: 'indicatorItems',
        component: () => import('../views/poultryStorage/guota/IndicatorItems.vue')
      },
      // 育种测定管理 - 任务管理
      {
        path: 'task',
        component: () => import('../views/poultryStorage/guota/task.vue')
      },
      {
        path: 'isScroll',
        component: () => import('../views/poultryStorage/guota/isScroll.vue')
      },
      // 信息发布管理
      {
        path: 'delivery',
        component: () => import('../views/poultryStorage/informationDelivery/delivery.vue')
      },
      // 系统设置 - 角色管理
      {
        path: 'userGroup',
        component: () => import('../views/poultryStorage/setSystem/userGroup.vue')
      },
      // 系统设置 - 人员管理
      {
        path: 'user',
        component: () => import('../views/poultryStorage/setSystem/user.vue')
      },
      // 系统设置 - 菜单管理
      {
        path: 'userCaidan',
        component: () => import('../views/poultryStorage/setSystem/userCaidan.vue')
      },
      // 大屏测试
      {
        path: 'demoScreen',
        component: () => import('../views/poultryStorage/demoScreen/index.vue')
      }
    ]
  },
  // 肉牛良种繁育系统
  {
    path: '/breedingcattle',
    component: Index,
    children: [
      // 欢迎登录
      {
        path: 'welcomeLogin',
        component: () => import('../views/breedingcattle/welcomeLogin/index.vue')
      },
      // 大屏
      {
        path: 'largeScreen',
        component: () => import('../views/breedingcattle/largescreen/index.vue')
      },
      // 主体管理
      {
        path: 'mainManagement',
        component: () => import('../views/breedingcattle/mainManagement/index.vue')
      },
      // 种畜管理
      {
        path: '/breedingcattle/livestock',
        component: { render: e => e('router-view') },
        children: [
          // 在栏种畜
          {
            path: 'inColumn',
            component: () => import('../views/breedingcattle/livestock/inColumn.vue')
          },
          // 种畜管理 - 配种记录
          {
            path: 'hybridization',
            component: () => import('../views/breedingcattle/livestock/hybridization.vue')
          },
          // 种畜管理 - 淘汰记录
          {
            path: 'obsolete',
            component: () => import('../views/breedingcattle/livestock/obsolete.vue')
          },

          // 种畜管理 - 出栏记录
          {
            path: 'outColumn',
            component: () => import('../views/breedingcattle/livestock/outColumn.vue')
          }
        ]
      },

      // 冻精管理
      {
        path: '/breedingcattle/frozenSemen',
        component: { render: e => e('router-view') },
        children: [
          // 冻精信息
          {
            path: 'info',
            component: () => import('../views/breedingcattle/frozenSemen/info.vue')
          },
          //  出入库记录
          {
            path: 'inoutRecord',
            component: () => import('../views/breedingcattle/frozenSemen/inoutRecord.vue')
          }
        ]
      },
      // 系统设置
      {
        path: '/breedingcattle/system',
        component: { render: e => e('router-view') },
        children: [
          // 系统设置 - 机构管理
          {
            path: 'organization',
            component: () => import('../views/breedingcattle/system/organization.vue')
          },
          // 系统设置 - 角色管理
          {
            path: 'role',
            component: () => import('../views/breedingcattle/system/role.vue')
          }, // 系统设置 - 人员管理
          {
            path: 'user',
            component: () => import('../views/breedingcattle/system/user.vue')
          },
          // 系统设置 - 菜单管理
          {
            path: 'menus',
            component: () => import('../views/breedingcattle/system/menus.vue')
          }
        ]
      }
    ]
  },
  // 养蜂PC端
  {
    path: '/wasp',
    component: Index,
    children: [
      // 首页
      {
        path: 'index',
        component: () => import('../views/beekeeping/index')
      },
      // 蜂厂管理
      {
        path: 'beefactory',
        component: () => import('../views/beekeeping/beefactory')
      },
      // 设备管理
      {
        path: 'device',
        component: () => import('../views/beekeeping/device')
      },
      // 设备管理
      {
        path: 'deviceview',
        component: () => import('../views/beekeeping/deviceview')
      },
      // 大屏
      {
        path: 'largescreen',
        component: () => import('../views/beekeeping/largescreen/index')
      }
    ]
  },
  // 养蜂PC端

  {
    path: '/products',
    component: Index,
    children: [
      // 大屏可视化
      {
        path: 'visual',
        component: () => import('../views/products/visual')
      },
      {
        path: 'companyDetails',
        component: () => import('../views/products/companyDetails')
      },
      // 企业管理
      {
        path: 'qiyeenterprisemanagement',
        component: () => import('../views/products/qiyeenterprisemanagement')
      },
      // 产品管理
      {
        path: 'enterprisemanagement',
        component: () => import('../views/products/enterprisemanagement')
      },
      // 监控
      {
        path: 'xuchandeviceview',
        component: () => import('../views/cattlesubsidy/xuchandeviceview')
      }
    ]
  },
  // 子州肉羊
  {
    path: '/zzry',
    component: Index,
    children: [
      // 大屏可视化
      {
        path: 'visual',
        component: () => import('../views/products/visual')
      },
      {
        path: 'companyDetails',
        component: () => import('../views/products/companyDetails')
      },
      // 企业管理
      {
        path: 'qiyeenterprisemanagement',
        component: () => import('../views/products/qiyeenterprisemanagement')
      },
      // 产品管理
      {
        path: 'enterprisemanagement',
        component: () => import('../views/products/enterprisemanagement')
      },
      // 监控
      {
        path: 'xuchandeviceview',
        component: () => import('../views/cattlesubsidy/xuchandeviceview')
      }
    ]
  },
  // 疫病预警监测
  {
    path: '/homeF',
    component: Index,
    children: [
      // 首页
      {
        path: 'index',
        component: () => import('../views/pestilence/index')
      },
      // 可视化大屏管理
      {
        path: 'visualLargeScreen',
        component: () => import('../views/pestilence/visualLargeScreen/index')
      }
    ]
  },
  {
    path: '/loanAdmin',
    component: Index,
    children: [
      // 首页
      {
        path: 'index',
        component: () => import('../views/loanAdmin/index')
      },
      // 产品管理
      {
        path: 'productManagement',
        component: () => import('../views/loanAdmin/productManagement')
      },
      // 需求管理
      {
        path: 'demandManagement',
        component: () => import('../views/loanAdmin/demandManagement')
      },
      // 贷后管理
      {
        path: 'collectionOfficer',
        component: () => import('../views/loanAdmin/collectionOfficer')
      },
      {
        path: 'farmDetails',
        component: () => import('../views/loanAdmin/farmDetails')
      },

      // 系统公告
      {
        path: 'systemNotice',
        component: () => import('../views/loanAdmin/systemNotice')
      },

      // 系统设置
      {
        path: '/loanAdmin/system',
        component: { render: e => e('router-view') },
        children: [
          // 机构管理
          {
            path: 'organization',
            component: () => import('../views/loanAdmin/system/organization.vue')
          },
          // 角色管理
          {
            path: 'role',
            component: () => import('../views/loanAdmin/system/role.vue')
          },
          // 人员管理
          {
            path: 'personnel',
            component: () => import('../views/loanAdmin/system/personnel.vue')
          },
          // 菜单管理
          {
            path: 'menus',
            component: () => import('../views/loanAdmin/system/menus.vue')
          }
        ]
      },

      // 申请管理
      {
        path: '/loanAdmin/apply',
        component: { render: e => e('router-view') },
        children: [
          // 推送
          {
            path: 'push',
            component: () => import('../views/loanAdmin/applicationManagement/pushAudit.vue')
          },
          // 待确认
          {
            path: 'confirmed',
            component: () => import('../views/loanAdmin/applicationManagement/confirmed.vue')
          },
          // 线下办理
          {
            path: 'offline',
            component: () => import('../views/loanAdmin/applicationManagement/offlineHandling.vue')
          },
          // 驳回
          {
            path: 'reject',
            component: () => import('../views/loanAdmin/applicationManagement/reject.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/loanaidinstitutions',
    component: Index,
    children: [
      // 首页
      {
        path: 'index',
        component: () => import('../views/loanaidinstitutions/index')
      },
      //产品管理
      {
        path: 'productmanagement',
        component: () => import('../views/loanaidinstitutions/productmanagement')
      },
      // 需求管理
      {
        path: 'demandmanagement',
        component: () => import('../views/loanaidinstitutions/demandmanagement')
      },
      // 申请管理
      {
        path: '/loanaidinstitutions/application',
        component: { render: e => e('router-view') },
        children: [
          // 待审核
          {
            path: 'pendingreview',
            component: () => import('../views/loanaidinstitutions/application/pendingreview.vue')
          },
          // 待用户确认
          {
            path: 'tobeconfirmed',
            component: () => import('../views/loanaidinstitutions/application/tobeconfirmed.vue')
          },
          // 线下办理
          {
            path: 'offlineprocessing',
            component: () => import('../views/loanaidinstitutions/application/offlineprocessing.vue')
          },
          // 已驳回
          {
            path: 'rejected',
            component: () => import('../views/loanaidinstitutions/application/rejected.vue')
          }
        ]
      },
      // 贷后管理
      {
        path: 'postloan',
        component: () => import('../views/loanaidinstitutions/postloan')
      },
      {
        path: 'farmDetails',
        component: () => import('../views/loanaidinstitutions/farmDetails')
      },
      // 系统设置
      {
        path: '/loanaidinstitutions/system',
        component: { render: e => e('router-view') },
        children: [
          // 人员管理
          {
            path: 'supervise',
            component: () => import('../views/loanaidinstitutions/system/supervise.vue')
          }
        ]
      }
    ]
  }
];

// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   console.log(isChunkLoadFailed,'/Loading chunk (\d)+ failed/g','路由懒加载找不到对应的moudle')
//   if (isChunkLoadFailed) {
//       window.location.reload();
//   }else{
//       console.log(error)
//   }
// });

// const whiteList=['/login','/home'];
// let user_token;
// router.beforeEach(async(to,from,next)=>{
//     user_token=get('USER_TOKEN');
//     if(user_token){
//         let res=await findHomemeau()
//         console.log(res);

//         next()
//     }else{
//         if(whiteList.indexOf(to.path)!==-1){
//             next();
//         }else{
//             next({path:'/home'})
//         }
//     }
// })
// router.onError((error) => {
//   const pattern = /Loading chunk.* failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   // const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     location.reload()
//   }
// });
// router.onError((error) => {
//   const jsPattern = /Loading chunk (\S)+ failed/g
//   const cssPattern = /Loading CSS chunk (\S)+ failed/g
//   const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
//   const targetPath = router.history.pending.fullPath
//   if (isChunkLoadFailed) {
//   localStorage.setItem('targetPath', targetPath)
//   window.location.reload()
//        }
//   }),
//   router.onReady(() => {
//   const targetPath = localStorage.getItem('targetPath')
//   const tryReload = localStorage.getItem('tryReload')
//   if (targetPath) {
//   localStorage.removeItem('targetPath')
//   if (!tryReload) {
//   router.replace(targetPath)
//   localStorage.setItem('tryReload', true)
//        } else {
//   localStorage.removeItem('tryReload')
//        }
//        }
//   })

const router = new VueRouter({
  // eslint-disable-next-line quotes
  mode: 'hash',
  base: process.env.BASE_URL,
  // eslint-disable-next-line comma-dangle
  routes
});

// const token = localStorage.getItem('token')
// router.beforeEach(async(to,from,next)=>{
//   console.log(token, 'token')
//     // if(token){
//         next()
//     // }else{
//     //   next()
//     // }
// })
// eslint-disable-next-line semi
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js